var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGonderilerim0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1149_86558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4814 30.2654H5.24628C4.89172 30.2654 4.60364 29.9821 4.60364 29.6334C4.60364 29.2848 4.89172 29.0015 5.24628 29.0015H16.4814C16.8359 29.0015 17.124 29.2848 17.124 29.6334C17.124 29.9821 16.8359 30.2654 16.4814 30.2654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71151 21.5813C9.54531 21.5813 9.37911 21.516 9.25723 21.3961L7.69495 19.8598L6.16591 21.3634C5.91107 21.614 5.51219 21.614 5.25735 21.3634C5.00251 21.1128 5.00251 20.7205 5.25735 20.4699L7.24067 18.5196C7.49551 18.269 7.89439 18.269 8.14923 18.5196L10.1658 20.5026C10.4206 20.7532 10.4206 21.1455 10.1658 21.3961C10.0439 21.516 9.87771 21.5813 9.71151 21.5813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69495 27.3889C7.34039 27.3889 7.05231 27.1056 7.05231 26.7569V18.9554C7.05231 18.6067 7.34039 18.3234 7.69495 18.3234C8.04951 18.3234 8.33759 18.6067 8.33759 18.9554V26.7569C8.33759 27.1056 8.04951 27.3889 7.69495 27.3889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0271 21.5813C15.8609 21.5813 15.6947 21.516 15.5728 21.3961L14.0105 19.8598L12.4815 21.3634C12.2266 21.614 11.8277 21.614 11.5729 21.3634C11.3181 21.1128 11.3181 20.7205 11.5729 20.4699L13.5562 18.5196C13.8111 18.269 14.2099 18.269 14.4648 18.5196L16.4813 20.5026C16.7362 20.7532 16.7362 21.1455 16.4813 21.3961C16.3595 21.516 16.1933 21.5813 16.0271 21.5813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0105 27.3889C13.6559 27.3889 13.3679 27.1056 13.3679 26.7569V18.9554C13.3679 18.6067 13.6559 18.3234 14.0105 18.3234C14.3651 18.3234 14.6531 18.6067 14.6531 18.9554V26.7569C14.6531 27.1056 14.3651 27.3889 14.0105 27.3889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1539 17.5389V33.6759C34.1539 34.0245 33.8659 34.3078 33.5113 34.3078H1.33502C0.980462 34.3078 0.692383 34.0245 0.692383 33.6759V1.47825C0.692383 1.12958 0.980462 0.846283 1.33502 0.846283H34.1539M1.97766 33.0439H32.8576V18.4651C32.8576 13.7144 32.8576 2.33903 32.8576 2.11022H1.97766V33.0439Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1149_86558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.4616,
    height: 33.4615,
    fill: "white",
    transform: "translate(0.692383 0.846283)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGonderilerim0);
export default __webpack_public_path__ + "static/media/gonderilerim_0.45ab69c503d879294569ed414e2b4611.svg";
export { ForwardRef as ReactComponent };